import React from "react";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";

function formatElapsedTime(seconds) {
  if (!seconds && seconds !== 0) return "-";

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
}

function StoresInSimulationTable({ stores }) {
  if (!stores || stores.length === 0) {
    return <p className="font-bold text-white">No stores in simulation</p>;
  }

  return (
    <Table className="tablesorter" responsive>
      <thead className="text-primary">
        <tr>
          <th>Name</th>
          <th>Location</th>
          <th>Since</th>
        </tr>
      </thead>
      <tbody>
        {stores.map((store) => (
          <tr key={store.id}>
            <td>{store.name || "-"}</td>
            <td>
              <Link to={`/stores/${store.id}`}>{store.location}</Link>
            </td>
            <td>{formatElapsedTime(store.elapsed_time)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default StoresInSimulationTable;
